import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'zeroPadding' })
export class ZeroPaddingPipe implements PipeTransform {
  transform(value: any, n: number = 6): string {
    return `${value}`.padStart(n, '0')
  }
}
